<template>
  <div class="container">
    <navbar />
    <router-view></router-view>
  </div>
</template>

<script>
import Navbar from '../components/Navbar.vue';

export default {
  name: 'Dashboard',
  components: {
    Navbar,
  },
};
</script>
